import { fetchBaseUrl } from "core/utils/common";
const apiURL = `${fetchBaseUrl({ port: 8000 })}/mcg/api`;

interface FetchPolicyPayload {
  repo_url: string;
  branch: string;
  file_path: string;
}

interface GeneratePayload {
  requirement: string;
  cloud_provider: string;
  validate: boolean;
}

interface ModifyPolicyPayload {
  existing_policy: string;
  modification_instructions: string;
  cloud_provider: string;
  modification_type: string;
  validate: boolean;
}

interface ValidatePayload {
  policy_code: string;
  policy_name: string;
  policy_category: string;
  cloud_provider: string;
  fetch_from_rag: boolean;
  max_retries: number;
}

interface PushToGitPayload {
  policy_code: string;
  File_name: string;
  cloud_provider: string;
  commit_message: string;
}

interface DownloadPayload {
  policy_code: string;
  policy_name: string;
}

const apiHeaders = {
  "Content-Type": "application/json",
  "X-API-Key": "DEV_API_KEY_MPCG"
};

/**
 * Fetch existing policy from repository
 */
export const fetchExistingPolicy = async (payload: FetchPolicyPayload) => {
  const response = await fetch(`${apiURL}/fetch-policy`, {
    method: "POST",
    headers: apiHeaders,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch existing policy");
  }

  return response.json();
};

/**
 * Generate a new policy
 */
export const generatePolicy = async (payload: GeneratePayload) => {
  const response = await fetch(`${apiURL}/generate`, {
    method: "POST",
    headers: apiHeaders,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to generate policy");
  }

  return response.json();
};

/**
 * Modify an existing policy
 */
export const modifyPolicy = async (payload: ModifyPolicyPayload) => {
  const response = await fetch(`${apiURL}/modify-policy`, {
    method: "POST",
    headers: apiHeaders,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to modify policy");
  }

  return response.json();
};

/**
 * Validate/test a policy
 */
export const validatePolicy = async (payload: ValidatePayload) => {
  const response = await fetch(`${apiURL}/test-policy`, {
    method: "POST",
    headers: apiHeaders,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to validate policy");
  }

  return response.json();
};

/**
 * Push policy to Git
 */
export const pushPolicyToGit = async (payload: PushToGitPayload) => {
  const response = await fetch(`${apiURL}/push-to-gitlab`, {
    method: "POST",
    headers: apiHeaders,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to push policy to Git");
  }

  return response.json();
};

/**
 * Download policy
 */
export const downloadPolicy = async (payload: DownloadPayload) => {
  const response = await fetch(`${apiURL}/download-policy`, {
    method: "POST",
    headers: apiHeaders,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to download policy");
  }

  return response.blob();
};
